module.exports = __webpack_public_path__ + "static/img/highStandard.4e560517.png";